import {Hub} from 'yougile-model'
import {crmStore} from '@components/crm/crm-store'
import {Board} from '@extensions/board'

export const getBarStyle = (
  stage: string,
  board?: Hub
): React.CSSProperties => {
  if (!board) {
    return {backgroundColor: '#D6E1EE'}
  }

  const column = Board.listColumns(board).find(col => col.title === stage)
  if (!column) {
    return {backgroundColor: '#D6E1EE'}
  }

  if (crmStore.isSucceededColumn(column)) {
    return {
      background: 'linear-gradient(180deg, #00C674 0%, #04F393 100%)'
    }
  }

  if (crmStore.isRejectedColumn(column)) {
    return {backgroundColor: '#F44336'}
  }

  return {backgroundColor: '#D6E1EE'}
}
